// ==============================
// App.js — Main App Routing
// ==============================

import React from "react";
import { RouterProvider } from "react-router-dom";

// ---- Context Providers ----
import { AuthProvider } from "./AuthContext";
import { ProjectProvider } from "./ProjectContext"; // <-- Add this import
import router from "./router";
// ---- Pages ----


// =========================
// Main App Component
// =========================
function App() {
  return (
    <ProjectProvider>
      <AuthProvider>
        <ProjectProvider>
          <RouterProvider router={router} />  
        </ProjectProvider>
      </AuthProvider>
    </ProjectProvider>
  );
}

export default App;
